import { render, staticRenderFns } from "./discountSummary.vue?vue&type=template&id=b9ae8fdc"
import script from "./discountSummary.vue?vue&type=script&lang=js"
export * from "./discountSummary.vue?vue&type=script&lang=js"
import style0 from "./discountSummary.vue?vue&type=style&index=0&id=b9ae8fdc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports